import { createFileRoute } from '@tanstack/react-router';
import { LayoutsStartersRoute } from './-components';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/layouts/starters')({
  component: LayoutsStartersRoute,
});
